import _ from 'lodash';
import Attribute from '../../V4/Attribute';
import Constants from '../../V4/NumericValues/Constants';
import { DecimalPrecisionError, DuplicateAttributeKeyError } from '../Errors';
import { exceedsMaximumPrecision } from '../../V4/MathHelpers';

const isNumericAttribute = (key, v1RuleSet) => {
  const whiteListedAttribute = v1RuleSet.whiteList.find(attribute => attribute.attributeKey.toLowerCase() === key.toLowerCase());

  let isKeyForNumericAttribute = false;
  if (whiteListedAttribute !== undefined) {
    isKeyForNumericAttribute =
      whiteListedAttribute.type === Attribute.Types.listOfRanges || whiteListedAttribute.type === Attribute.Types.formula;
  }

  return isKeyForNumericAttribute;
};

/**
 * Check if the given selection has a duplicate key by using mapKeys to set all keys to lowercase
 * and compare the number of keys to the original object.
 */
const hasDuplicateKey = attributeSelection =>
  !_.isEqual(
    _(attributeSelection)
      .keys()
      .value().length,
    _(attributeSelection)
      .mapKeys((value, key) => key.toLowerCase())
      .keys()
      .value().length,
  );

/**
 * Validate numeric values in attributeSelection
 */
const validateNumerics = (attributeSelection, v1RuleSet) => {
  _.each(attributeSelection, (value, key) => {
    if (isNumericAttribute(key, v1RuleSet)) {
      const numberValue = Number(value);
      if (_.isFinite(numberValue) && exceedsMaximumPrecision(numberValue)) {
        const msg =
          `Attribute selection ${value} for attribute "${key}" exceeds maximum decimal ` +
          `precision of ${Constants.MAXIMUM_DECIMAL_PRECISION}`;
        throw new DecimalPrecisionError(msg);
      }
    }
  });
};

/**
 * Static functions operating on Attribute Selection dictionaries.
 */
export default class AttributeSelection {
  /**
   * Validate the given attribute selection
   * @param {object} attributeSelection - Attribute selection represented by key value pairs.
   * @param {object} v1RuleSet - The rule set whose attributes are selected by this selection.
   */
  static validate(attributeSelection, v1RuleSet) {
    if (hasDuplicateKey(attributeSelection)) {
      throw new DuplicateAttributeKeyError('Attribute selection contains duplicate keys.');
    }

    validateNumerics(attributeSelection, v1RuleSet);
  }
}
